import BasicRouterView from "../../../components/BasicRouterView.vue";

const inventario = {
  path: "invt",
  redirect: { name: "salvos" },
  meta: {
    label: "Inventario",
    icon: "add",
    show: true,
  },
  component: BasicRouterView,
  children: [
    {
      path: "inventario/inventario-listar",
      name: "inventario-listar",
      meta: {
        label: "Listar",
        icon: "settings",

        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "../Inventario/views/Listar.vue"),
    },
    {
      path: "inventario/inventario-upload",
      name: "inventario-upload",
      meta: {
        label: "Listar",
        icon: "settings",

        show: false,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "../Inventario/views/Upload.vue"),
    },
    {
      path: "inventario/inventario-novo/:id",
      name: "inventario-novo",
      meta: {
        label: "Listar",
        icon: "settings",

        show: false,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "../Inventario/views/Novo.vue"),
    },
    {
      path: "inventario/inventario-imprimir/:id",
      name: "inventario-imprimir",
      meta: {
        label: "Listar",
        icon: "settings",

        show: false,
      },
      component: () =>
        import(
          /* webpackChunkName: "pdt" */ "../Inventario/views/Imprimir.vue"
        ),
    },
    {
      path: "inventario/inventario-imprimir-contado/:id",
      name: "inventario-imprimir-contado",
      meta: {
        label: "Listar",
        icon: "settings",

        show: false,
      },
      component: () =>
        import(
          /* webpackChunkName: "pdt" */ "../Inventario/views/ImprimirContado.vue"
        ),
    },
  ],
};

export default inventario;
